import { Section } from '@/components/ui/Page'
import { cn } from '@/lib/cn'
import { ACCENT_LABEL, ACCENT_SWATCH, ACCENTS, useAccent } from '@/lib/theme'

/**
 * Settings > Theme: the colour the Studio uses for buttons, the page you're
 * on in the menu, ticked boxes and focus. Saved in this browser, like dark
 * mode, so each device keeps its own.
 */
export function ThemeSettingsPage() {
  const { accent, setAccent } = useAccent()

  return (
    <div className="max-w-3xl pt-5">
      <Section
        title="Theme colour"
        description="Used for buttons, the page you're on in the menu, ticked boxes and links. Saved on this device. Dark mode is at the bottom of the menu."
      >
        <div className="grid grid-cols-3 gap-3 sm:grid-cols-5" role="radiogroup" aria-label="Theme colour">
          {ACCENTS.map((key) => (
            <button
              key={key}
              type="button"
              role="radio"
              aria-checked={accent === key}
              onClick={() => setAccent(key)}
              className={cn(
                'flex flex-col items-center gap-2 rounded-lg p-2 text-[length:var(--text-sm)] hover:bg-[var(--color-wash-strong)]',
                accent === key && 'bg-[var(--color-wash-strong)] font-semibold',
              )}
            >
              <span
                className={cn('size-10 rounded-full', accent === key && 'ring-2 ring-offset-2 ring-offset-[var(--surface-card)]')}
                style={{ backgroundColor: ACCENT_SWATCH[key], ['--tw-ring-color' as string]: ACCENT_SWATCH[key] }}
              />
              {ACCENT_LABEL[key]}
            </button>
          ))}
        </div>
      </Section>
    </div>
  )
}
